"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _util = require("../../util");
var ValidOffer = function ValidOffer(_ref) {
  var id = _ref.id,
    minMonthlyPayments = _ref.minMonthlyPayments,
    productTerm = _ref.productTerm,
    minimumApr = _ref.minimumApr,
    totalCost = _ref.totalCost,
    monthlyIndex = _ref.monthlyIndex,
    register = _ref.register;
  var bem = (0, _util.bemClass)('revision-offers');
  return /*#__PURE__*/_react.default.createElement("label", {
    htmlFor: id,
    className: bem('valid-offer')
  }, /*#__PURE__*/_react.default.createElement("input", Object.assign({}, register('selectedOffer', {
    required: true
  }), {
    className: bem('valid-offer', 'valid-offer-radio'),
    type: "radio",
    id: id,
    value: id
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: bem('valid-offer-details')
  }, /*#__PURE__*/_react.default.createElement("strong", null, minMonthlyPayments, "/mo"), monthlyIndex && /*#__PURE__*/_react.default.createElement("sup", null, monthlyIndex), "\xA0(sugg) for ", productTerm, " months", /*#__PURE__*/_react.default.createElement("br", null), "at ", minimumApr, " APR - ", totalCost, " total"));
};
ValidOffer.propTypes = {
  id: _propTypes.default.number.isRequired,
  minMonthlyPayments: _propTypes.default.string.isRequired,
  productTerm: _propTypes.default.number.isRequired,
  minimumApr: _propTypes.default.string.isRequired,
  totalCost: _propTypes.default.string.isRequired,
  monthlyIndex: _propTypes.default.number,
  register: _propTypes.default.func.isRequired
};
ValidOffer.defaultProps = {
  monthlyIndex: null
};
var _default = ValidOffer;
exports.default = _default;
